import React, { useState } from "react";
import { ClientAccessUser, User } from "@/types/User.tsx";
import { isBitramp } from "@/utils/utils";

interface AddClientAccessProps {
  members: ClientAccessUser[];
  users: User[] | null;
  handleAddUserToAccess: (userIds: number[]) => void;
  onClose: () => void;
}

const AddClientAccess: React.FC<AddClientAccessProps> = ({
  members,
  handleAddUserToAccess,
  onClose,
  users,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const [checkedUsers, setCheckedUsers] = useState<number[]>(
    members.map((member) => member.id)
  );

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const filteredUsers = users?.filter(
    (member) =>
      member.first_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const onCancel = () => {
    setSearchTerm("");
    onClose();
  };

  const onAdd = () => {
    handleAddUserToAccess(checkedUsers);
    setSearchTerm("");
    onClose();
  };

  return (
    <div
      className={`flex flex-1 mt-5 flex-col rounded-lg  ${
        isBitramp() ? "bg-[#2b2b2b]" : "bg-white"
      }`}
    >
      <div className="flex justify-start items-center py-3 px-5">
        <p className="Text dark-blue dark-blue semi-bold">Access Client</p>
      </div>

      <div
        className={`relative w-full py-3 px-5 ${
          isBitramp() ? "bg-[#2b2b2b]" : "bg-white"
        }`}
      >
        <div className="absolute inset-y-0 left-5 flex items-center pointer-events-none">
          <svg
            className="ml-2"
            width="15"
            height="15"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.6146 18.0419L15.8489 14.2873C17.0639 12.7395 17.7231 10.8281 17.7207 8.86035C17.7207 7.10794 17.201 5.39488 16.2275 3.9378C15.2539 2.48073 13.8701 1.34508 12.2511 0.674457C10.632 0.00383902 8.85052 -0.171625 7.13178 0.170253C5.41304 0.512131 3.83428 1.356 2.59514 2.59514C1.356 3.83428 0.512131 5.41304 0.170253 7.13178C-0.171625 8.85052 0.00383902 10.632 0.674457 12.2511C1.34508 13.8701 2.48073 15.2539 3.9378 16.2275C5.39488 17.201 7.10794 17.7207 8.86035 17.7207C10.8281 17.7231 12.7395 17.0639 14.2873 15.8489L18.0419 19.6146C18.1448 19.7184 18.2673 19.8008 18.4023 19.857C18.5373 19.9132 18.682 19.9422 18.8282 19.9422C18.9744 19.9422 19.1192 19.9132 19.2542 19.857C19.3891 19.8008 19.5116 19.7184 19.6146 19.6146C19.7184 19.5116 19.8008 19.3891 19.857 19.2542C19.9132 19.1192 19.9422 18.9744 19.9422 18.8282C19.9422 18.682 19.9132 18.5373 19.857 18.4023C19.8008 18.2673 19.7184 18.1448 19.6146 18.0419ZM2.21509 8.86035C2.21509 7.54604 2.60483 6.26125 3.33502 5.16844C4.06521 4.07563 5.10306 3.22389 6.31732 2.72093C7.53158 2.21797 8.86772 2.08637 10.1568 2.34278C11.4458 2.59918 12.6299 3.23208 13.5593 4.16144C14.4886 5.0908 15.1215 6.27487 15.3779 7.56392C15.6343 8.85297 15.5027 10.1891 14.9998 11.4034C14.4968 12.6176 13.6451 13.6555 12.5523 14.3857C11.4594 15.1159 10.1747 15.5056 8.86035 15.5056C7.09791 15.5056 5.40767 14.8055 4.16144 13.5593C2.91521 12.313 2.21509 10.6228 2.21509 8.86035Z"
              fill={`${isBitramp() ? "#9F9F9F" : "#737791"}`}
              fillOpacity="0.19"
            />
          </svg>
        </div>

        <input
          type="text"
          value={searchTerm}
          onChange={handleSearch}
          placeholder="Search"
          className={`w-full pl-10 pr-4 py-2 border border-[#d5d5d5] bg-[#f9f9f9] text-gray-700 placeholder-gray-400 Input ${
            isBitramp()
              ? "placeholder:text-[#9F9F9F] border-[#464646] !bg-[#464646] !text-[#fff]"
              : ""
          }`}
        />
      </div>

      <div className="pr-3 pl-2">
        <div
          className={`flex flex-col gap-2 pb-3 px-3 min-h-[25rem] max-h-[25rem] overflow-y-scroll  ${
            isBitramp()
              ? "bg-[#2b2b2b] crypto-list_bitramp "
              : "bg-white crypto-list "
          }`}
        >
          {filteredUsers?.map((member) => (
            <div
              key={member.id}
              className="flex justify-between items-center p-1"
            >
              <p className="Text dark-blue medium">
                {member?.first_name?.length === 0 ? "N/A" : member.first_name} -{" "}
                {member.email}
              </p>
              <input
                type="checkbox"
                onChange={() => {
                  if (checkedUsers.includes(member.id)) {
                    setCheckedUsers(
                      checkedUsers.filter((id) => id !== member.id)
                    );
                  } else {
                    setCheckedUsers([...checkedUsers, member.id]);
                  }
                }}
                checked={checkedUsers.includes(member.id)}
                className={`appearance-none w-5 h-5 rounded-full border-2  focus:outline-none focus-visible:outline-none ${
                  isBitramp()
                    ? "bg-[#262626] border-[#464646] checked:bg-[#8afefd] checked:border-[#464646]"
                    : "border-gray-400 checked:bg-gray-900 checked:border-gray-900"
                }`}
              />
            </div>
          ))}
        </div>

        <div className="flex justify-end items-center py-4">
          <button
            className={`mr-2 ${
              isBitramp() ? "Edit_button_bitramp" : "Outline_red_button"
            }`}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className={` ${
              isBitramp() ? "Upload_button_bitramp" : "Primary_button"
            }`}
            onClick={onAdd}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddClientAccess;
